import { createContext } from "react";
import { createDispatchHook, createSelectorHook, } from "react-redux";
export const ConfigurationReduxContext = createContext(null);
ConfigurationReduxContext.displayName = "ConfigurationReduxContext";
const useDispatchHook = createDispatchHook(ConfigurationReduxContext);
/**
 * Custom useDispatch
 */
export const useConfigurationDispatch = useDispatchHook;
/**
 * Custom useSelector
 */
export const useConfigurationSelector = createSelectorHook(ConfigurationReduxContext);
//# sourceMappingURL=ConfigurationReduxContext.js.map